import React from 'react';
import { Link } from 'react-router-dom';
import careerHeroImage from '../../assets/brand/career.jpg';

const CareersHero: React.FC = () => {
  return (
    <section className="bg-[#F8FAFE] pt-10 pb-14">
      <div className="layout-container max-w-[1360px] mx-auto px-5">
        <div className="w-full text-center flex flex-col items-center">
          <nav className="flex justify-center mb-2" aria-label="Breadcrumb">
            <ol className="flex items-center space-x-2 text-[12px] font-title font-light text-[#919191]">
              <li>
                <Link to="/" className="hover:text-primary transition-colors">Homepage</Link>
              </li>
              <li>
                <svg width="14" height="14" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6.68 3.06L12 9l-5.32 5.94" stroke="#919191" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </li>
              <li className="text-[#212121] font-medium">Careers</li>
            </ol>
          </nav>

          <div className="mb-10 flex flex-col items-center">
            <h1 className="font-title text-[36px] md:text-[46px] font-semibold leading-[1.08] tracking-[-0.02em] text-[#212121] text-center max-w-[640px] max-[700px]:text-[32px]">
              Careers <span className="text-[#919191]">at Bao Technologies</span>
            </h1>
            <p className="mt-3 font-description text-[13px] md:text-[14px] font-light leading-[1.55] text-[#919191] max-w-[560px] text-center">
              Step into a role where your skills are challenged, your ideas are valued, and you have the opportunity to build real products that drive progress and change.
            </p>
          </div>
        </div>

        <div className="flex flex-col lg:flex-row gap-4 items-stretch min-h-[320px] md:min-h-[360px]">
          <div className="w-full lg:w-[38%] bg-[#212121] rounded-[20px] p-6 md:p-8 flex flex-col justify-end text-white relative overflow-hidden shadow-[0_12px_30px_rgba(0,0,0,0.08)]">
            <div className="absolute left-[-10px] top-[60px] w-[90%] h-[70%] bg-gradient-to-b from-transparent to-black/40 blur-[12px] z-0" />
            <div className="relative z-10 flex flex-col gap-2">
              <div className="flex flex-col items-start gap-2 mb-2">
                <span className="inline-flex px-3 py-1 rounded-full border border-[#B8B8B8] text-[10px] font-description font-normal text-[#FAFAFA]">
                  Careers
                </span>
                <h2 className="font-title text-[28px] md:text-[32px] font-medium leading-[1.1] text-[#FAFAFA]">
                  Why join Bao Technologies ?
                </h2>
              </div>
              <p className="font-description text-[12px] md:text-[13px] font-light leading-[1.5] text-[#FAFAFA] max-w-[320px]">
                Reach out to us today to explore how our technology solutions can drive your business forward. Our team of experts is ready to assist you.
              </p>
            </div>
          </div>

          <div className="flex-1 relative rounded-[20px] overflow-hidden group shadow-[0_12px_30px_rgba(0,0,0,0.08)] min-h-[280px]">
            <img
              src={careerHeroImage}
              alt="Team collaboration"
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent z-0" />
            <div className="absolute inset-0 z-10 flex flex-col justify-end p-6 md:p-8 gap-4">
              <h3 className="text-[#FAFAFA] font-title text-[20px] md:text-[26px] font-medium leading-[1.2] max-w-[560px]">
                Work on meaningful projects that solve real-world problems and directly impact users, businesses, and communities.
              </h3>

              <div className="flex flex-wrap items-center gap-2">
                <div className="flex items-center gap-2">
                  <div className="flex items-center gap-2">
                    <div className="w-4 h-4 bg-white text-black rounded-sm flex items-center justify-center">
                      <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2L2 22h20L12 2z"/></svg>
                    </div>
                    <span className="text-white text-[12px] font-medium font-title">Real Impactful Work</span>
                  </div>
                  <svg width="14" height="14" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.68 3.06L12 9l-5.32 5.94" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>

                <div className="flex items-center gap-2 opacity-30">
                  <div className="flex items-center gap-2">
                    <div className="flex items-center gap-2">
                      <div className="w-4 h-4 bg-white text-black rounded-sm flex items-center justify-center">
                        <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2L2 22h20L12 2z"/></svg>
                      </div>
                      <span className="text-white text-[12px] font-light font-title">Continuous Growth</span>
                    </div>
                    <svg width="14" height="14" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6.68 3.06L12 9l-5.32 5.94" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>

                  <div className="flex items-center gap-2">
                    <div className="flex items-center gap-2">
                      <div className="w-4 h-4 bg-white text-black rounded-sm flex items-center justify-center">
                        <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2L2 22h20L12 2z"/></svg>
                      </div>
                      <span className="text-white text-[12px] font-light font-title">Supportive Team Culture</span>
                    </div>
                    <svg width="14" height="14" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6.68 3.06L12 9l-5.32 5.94" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>

                  <div className="flex items-center gap-2">
                    <div className="w-4 h-4 bg-white text-black rounded-sm flex items-center justify-center">
                      <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2L2 22h20L12 2z"/></svg>
                    </div>
                    <span className="text-white text-[12px] font-light font-title">Room to Innovate</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CareersHero;
